import React from 'react';
import ReactDOM from 'react-dom';

interface STATE {
  isVisible: boolean
}

const withVisibility = (WrappedComponent: any): any => (
  class extends React.Component<any, STATE> {
    private OBSERVER: IntersectionObserver;
    private OBSERVER_OPTS = {
      root: null,
      rootMargin: '0px',
      threshold: 1.0
    };
    private componentRef: any = null;

    state = {
      isVisible: false
    }

    componentDidMount() {
      if (this.props.trackVisibility !== false) {
        this.OBSERVER = new IntersectionObserver(this.observerCallback, this.OBSERVER_OPTS);
        // @ts-ignore
        this.OBSERVER.observe(this.componentRef);
      }
    }

    componentWillUnmount() {
      this.OBSERVER?.disconnect();
    }

    private assignRef = (ref: any) => {
      this.componentRef = ReactDOM.findDOMNode(ref);
    };

    private observerCallback = () => {
      this.setState({ isVisible: true }, () => {
        this.OBSERVER.disconnect();
      });
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          isVisible={this.state.isVisible}
          ref={this.assignRef}
        />
      );
    }
  }
);

export default withVisibility;
